import React from 'react';
import GymList from '../components/gym/GymList';
import { getGymsState } from '../view/HTTPService';

/**
 * /gymsstate - Dojos filtrados por estado (dropdown no header).
 * Não carrega nada até selecionar um estado.
 */
export default function GymsStatePage() {
    return (
        <GymList
            titleKey="msg.jkaGymsAffiliateByState"
            fetchGyms={null}
            filterByState={getGymsState}
        />
    );
}
